import React from "react";
import { FaFacebook, FaGithub, FaLinkedinIn } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import Fade from "react-reveal/Fade";
import Zoom from "react-reveal/Zoom";
import AboutMe from "../../Assets/Images/about-me.jpg";
import "./About.scss";

const About = () => {
  return (
    <div className="custom-bg about-area">
      <div className="container pt-5 pb-5">
        <div className="row gx-0 mt-5 mb-3 d-flex justify-content-center align-items-center">
          <Zoom>
            <div className="col-md-6 px-4">
              <div className="blurry2 text-center py-5 px-4 mb-5">
                <img className="about-me-image mb-4" src={AboutMe} alt="" />
                <h3>Rafi Ferdos</h3>
                <h5 className="mb-3">MERN-Stack Developer</h5>
                <div className="custom-social-links">
                  <a
                    href="https://www.facebook.com/rafiferdos1/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <FaFacebook className="social-link-item" />
                  </a>
                  <a href="https://www.linkedin.com/in/rafiferdos/" target="_blank" rel="noreferrer">
                    <FaLinkedinIn className="social-link-item" />
                  </a>
                  <a href="https://github.com/rafiferdos" target="_blank" rel="noreferrer">
                    <FaGithub className="social-link-item" />
                  </a>
                  <a href="mailto:rafiferdos@gmail.com" target="_blank" rel="noreferrer">
                    <IoMail className="social-link-item" />
                  </a>
                </div>
              </div>
            </div>
          </Zoom>
          <Fade right>
            <div className="col-md-6">
              <h1 className="display-3 fw-bold custom-font">
                Introducing <span className="custom-font-color">Myself</span>
                <span className="dot">.</span>
              </h1>
              <hr className="divider mb-5" />
              <p className="about-me-text2">
                I am a MERN-Stack WEB Developer. I'm working with React.js,
                Node.js and MongoDB. I also have experience in developing static
                websites using HTML5, CSS3 and JavaScript (ES6). I am a quick
                learner and self-motivated programmer.I always work hard and
                smart to complete my everyday tasks quick and in fancy style.
                That's why I am always ready to accomplish any task by working
                hard. I always not only focus on learning new technology but
                also apply it in my creative projects. My goal is to become A
                World-Class Professional Web Developer.
              </p>
              <h2 className="custom-font">
                Technologies{" "}
                <span className="custom-font-color">I'm working </span>with
                <span className="custom-font-color">.</span>
                <hr className="divider mb-3" />
              </h2>
              <div className="frontend">
                <h3 className="custom-font">
                  <span className="custom-font-color">Front</span>End
                  <span className="custom-font-color">.</span>
                </h3>
                <ul className="d-flex flex-wrap custom-circle">
                  <li className="mx-2">JavaScript (ES6)</li>
                  <li className="mx-2">React.js</li>
                  <li className="mx-2">Redux.js</li>
                  <li className="mx-2">Material-UI</li>
                  <li className="mx-2">HTML5</li>
                  <li className="mx-2">CSS3</li>
                  <li className="mx-2">Bootstrap 5</li>
                  <li className="mx-2">React Bootstrap</li>
                  <li className="mx-2">Tailwind CSS</li>
                </ul>
              </div>
              <div className="backend">
                <h3 className="custom-font">
                  <span className="custom-font-color">Back</span>End
                  <span className="custom-font-color">.</span>
                </h3>
                <ul className="d-flex flex-wrap custom-circle">
                  <li className="mx-2">MongoDB</li>
                  <li className="mx-2">NodeJS</li>
                  <li className="mx-2">ExpressJS</li>
                </ul>
              </div>
              <div className="tools">
                <h3 className="custom-font">
                  Tools<span className="custom-font-color">.</span>
                </h3>
                <ul className="d-flex flex-wrap custom-circle">
                  <li className="mx-2">VS Code</li>
                  <li className="mx-2">Git/Github</li>
                  <li className="mx-2">Chrome Dev Tool</li>
                  <li className="mx-2">NPM & YARN</li>
                  <li className="mx-2">Firebase</li>
                  <li className="mx-2">Netlify</li>
                  <li className="mx-2">Heroku</li>
                </ul>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </div>
  );
};

export default About;
